import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../helpers/api_helper";

const api = new APIClient();

export const createReminder = createAsyncThunk(
  "reminders/createReminder",
  async (data) => {
    return await api.create("/automated-reminders/create", data);
  }
);

export const fetchUserReminders = createAsyncThunk(
  "reminders/fetchUserReminders",
  async () => {
    return await api.get("/automated-reminders/my-reminders");
  }
);

export const getReminderById = createAsyncThunk(
  "reminders/getReminderById",
  async (reminderId) => {
    return await api.get(`/automated-reminders/${reminderId}`);
  }
);

export const updateReminder = createAsyncThunk(
  "reminders/updateReminder",
  async ({ reminderId, data }) => {
    return await api.put(`/automated-reminders/${reminderId}`, data);
  }
);

export const deleteReminder = createAsyncThunk(
  "reminders/deleteReminder",
  async (reminderId) => {
    return await api.delete(`/automated-reminders/${reminderId}`);
  }
);

const initialState = {
  reminders: [],
  selectedReminder: null,
  loading: false,
  error: null,
  total: 0,
};

const reminderSlice = createSlice({
  name: "Reminders",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(createReminder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createReminder.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.data) {
          state.reminders.push(action.payload.data);
        }
      })
      .addCase(createReminder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchUserReminders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserReminders.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.reminders && Array.isArray(action.payload.reminders)) {
          state.reminders = action.payload.reminders;
          state.total = action.payload.total || 0;
        }
      })
      .addCase(fetchUserReminders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.reminders = [];
      })
      .addCase(getReminderById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReminderById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedReminder = action.payload;
      })
      .addCase(getReminderById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateReminder.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateReminder.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.reminders.findIndex(
          (r) => r.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.reminders[index] = action.payload.data;
        }
      })
      .addCase(updateReminder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteReminder.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteReminder.fulfilled, (state, action) => {
        state.loading = false;
        state.reminders = state.reminders.filter(
          (r) => r.id !== action.meta.arg
        );
      })
      .addCase(deleteReminder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default reminderSlice.reducer;
